import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { IPayPalConfig, ICreateOrderRequest } from 'ngx-paypal';
import { CartService } from '../../../../../../../../services/generar-pedido/cart/cart.service';
import { LoginService } from '../../../../../../../../services/login/login.service';
import { SwalService } from '../../../../../../../../services/swal/swal.service';
import { CheckoutService } from '../../../../utils/services/checkout.service';
import { catchError, switchMap } from 'rxjs/operators';
import { DataResponseOrder } from '../../../../../../../../core/model/DataOrder';
import { ResumenData } from '../../../../../../../../core/model/DataCart';
import { of } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
@Component({
  selector: 'app-paypal',
  templateUrl: './paypal.component.html',
  styleUrls: ['./paypal.component.scss']
})
export class PaypalComponent implements OnInit {
  public payPalConfig?: IPayPalConfig;
  @Output() clickSubmit: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() loading: boolean;
  @Input() textoLoading: string;
  @Input() disabled: boolean;

  public render: any = null;

  constructor(
    private service: CheckoutService,
    private cartService: CartService,
    private router: Router,
    private swal: SwalService,
    private login: LoginService,
    private matSnackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.initConfig();
  }

  private initConfig(): void {
    const cliente = this.login.getDataClientePedido();
    this.payPalConfig = {
      currency: 'MXN',
      clientId: 'AcxQCTrYRjY8EVhpCBaSX_Vj_-yMK4cDktKXlF_19mvB6mlBLXHyn7Sh8Zr3WnKSTaqKyFyvyVFxp_uK',
      // tslint:disable-next-line: no-angle-bracket-type-assertion
      createOrderOnClient: (data) => <ICreateOrderRequest>{
        intent: 'CAPTURE',
        purchase_units: [{
          amount: {
            currency_code: 'MXN',
            value: this.getResumen().total.toFixed(2),
            breakdown: {
              item_total: {
                currency_code: 'MXN',
                value: this.getResumen().total.toFixed(2)
              }
            }
          },
          items: [{
            name: 'Pago de KABIK',
            quantity: '1',
            category: 'DIGITAL_GOODS',
            unit_amount: {
              currency_code: 'MXN',
              value: this.getResumen().total.toFixed(2),
            },
          }]
        }],
        application_context: {
          cancel_url: 'https://kabik.mx/checkout'
        }
      },
      advanced: {
        commit: 'true'
      },
      style: {
        label: 'paypal',
        layout: 'horizontal',
        color: 'blue',
        size: 'responsive',
        shape: 'rect',
        tagline: false
      },
      onInit: (data, actions) => {

      },
      onApprove: (data, actions) => {

      },
      onClientAuthorization: (data) => {

        this.placerOrder(data);
      },
      onCancel: (data, actions) => {
        this.clickSubmit.emit(false);
        console.log('OnCancel', data, actions);
      },
      onError: err => {
        this.clickSubmit.emit(false);
        this.swal.swalError(
          'Pago paypal',
          'Hubo un inconveniente con la plataforma de paypal, intente más tarde.<br/><br/>Error: ' + err.message +
          '<br/><br/><div style="font-size: 14px;"><p>Número de cliente: ' + cliente.client_number + '<br/>Nombre: ' + cliente.company_name + '<br/>Correo electrónico: ' + cliente.email + '<br/>Almacén: ' + cliente.almacenPre + '</p></div>');
      },
      onClick: (data, actions) => {

        // console.log('is disabled',this.disabled );
        if (!this.login.isLogged()) {
          this.matSnackBar.open('Tu sesión ha expirado. Vuelve a iniciar sesión', 'Ok', {
            duration: 10000,
            horizontalPosition: 'center',
          });
          this.router.navigate(['iniciar_session/login']);
          return;
        }
        this.clickSubmit.emit(true);
        // console.log("onClick", data, actions);
      },
    };

    setTimeout(() => {
      this.render = true;
    }, 1000);
  }

  private paymentValidate = (data: any): boolean => {
    return data.status === 'COMPLETED';
  }

  /**
   * @param data la información que proporciona paypal
   * cuando se realiza la transacción
   * Este metodo se ejecutara cuando el cliente haya pagado en paypal
   */
  private placerOrder = (data): void => {
    if (this.paymentValidate(data)) {
      this.cartService.guardCheckout = true;
      const detailTranction = {
        id: data.id,
        status: 'Aprobado',
        pagadoEn: 'paypal',
        totalPagado: this.getResumen().total,
        comision: this.getResumen().comision,
        totalRecibido: this.getResumen().totalRecibido
      };
      this.service.validarParidad().pipe(
        catchError(error => this.handleError(error, 'paridad', data)),
        switchMap((resDataParidad: any) => this.generarPedido(resDataParidad, detailTranction))
      ).pipe(catchError(error => this.handleError(error, 'pedido', data))
      ).subscribe((valueresponseDataOrder: DataResponseOrder) => this.successfulOrder(valueresponseDataOrder, data));
    }
  }
  /**
   * Metodo que devuelve el resumen de la compra
   * el resumen de compra se extrae del @localstorage
   */
  private getResumen = (): ResumenData => {
    const resumen = JSON.parse(localStorage.getItem('resumen-cart-login'));
    return resumen;
  }
  /**
   * Este metodo se utiliza cuando regresa la peticion de la paridad
   * recibe como parametros
   * @param resDataParidad la respuesta de la paridad
   * @param detailTranction los datos de transaccion de paypal
   * Este este metodo valida si la paridad es correcta
   * si es así entonces retorna el susbcribe del pedido para generarse
   * si la paridad es invalida entonces devolvemos un susbcribe @null
   */
  private generarPedido = (resDataParidad, detailTranction) => {
    if (resDataParidad.status) {    // validamos la paridad que regrese true
      return this.service.placeOrder('contado', detailTranction, true);
    }
    this.clickSubmit.emit(false);
    return of(null);
  }

  /**
   * Este metodo es el que se ejecuta una vez que ya se haya echo la peticion del pedido
   * recibe como parametros
   * @param responseDataOrder la respuesta del pedido
   * @param data los datos de transaccion de paypal
   * este metodo valida la respuesta del pedido
   * si la respuesta devuelve un  @false en ok entonces fue exitoso
   */
  private successfulOrder = (responseDataOrder: DataResponseOrder, data) => {
    const cliente = this.login.getDataClientePedido();
    if (responseDataOrder) {
      if (responseDataOrder.error === false) {  // VALIDAMOS SI TODO FUE EXITOSO
        // si es así lo redireccionamos al ORDER COMPLETE
        // en este caso le mandamos el id de transacción mostrarselo al cliente

        const pedidoSucursal = Object.keys(responseDataOrder.pedidoSucursal).length === 0 ? 0 : responseDataOrder.pedidoSucursal.pedidoId;
        const pedidoCedis = Object.keys(responseDataOrder.pedidoCedis).length === 0 ? 0 : responseDataOrder.pedidoCedis.pedidoId;
        this.clickSubmit.emit(false);
        this.router.navigate(
          ['checkout/order-complete',
            pedidoSucursal,
            pedidoCedis,
            data.id,
            'paypal',
            'contado']
        );
        // this.cartService.destroyCart();
        // this.spinner.show();
      } else {  // si no es así entonces es por que no hay existencias
        this.swal.swalAlert('¡Upps!',
          'Lo sentimos, ' + responseDataOrder.message +
          '<br/><br/>Favor de comunicarse con el administrador del sitio para dar seguimiento. Tu número de transacción generado por PAYPAL es  : '
          + data.id +
          '<br/><br/><div style="font-size: 14px;"><p>Número de cliente: ' + cliente.client_number + '<br/>Nombre: ' + cliente.company_name + '<br/>Correo electrónico: ' + cliente.email + '<br/>Almacén: ' + cliente.almacenPre + '</p></div>');
      }
    }
  }

  /**
   * este metodo es para capturar el error que nos devuelve
   * recibe como parametros
   * @param error el error nativo
   * @param to de donde se esta ejecuando el error
   * @param data los datos de transaccion
   * Este metoso recibe los datos de transaccion de paypal por si el usuario
   * realizo el pago correctamente, pero no se realizo el pedido
   */
  private handleError = (error: HttpErrorResponse | any, to: string, data) => {
    const cliente = this.login.getDataClientePedido();
    this.clickSubmit.emit(false);
    switch (to) {
      case 'paridad':
        this.swal.swalError('Pago paypal', 'Lo sentimos, estamos experimentando problemas con la plataforma, favor de comunicarse con el administrador del sitio para dar seguimiento a tu pedido. ' +
          '<br><br><p>Tu número de transacción generado por PAYPAL es: </p> <b>' + data.id + '</b><br/><br/>Error: ' + error.message +
          '<br/><br/><div style="font-size: 14px;"><p>Número de cliente: ' + cliente.client_number + '<br/>Nombre: ' + cliente.company_name + '<br/>Correo electrónico: ' + cliente.email + '<br/>Almacén: ' + cliente.almacenPre + '</p></div>');
        return of(error);
      case 'pedido':
        this.swal.swalError('Pago paypal',
          'Lo sentimos, tuvimos un inconveniente al generar el pedido, favor de comunicarse con el administrador del sitio para dar seguimiento a tu pedido.' + '<br><br><p>Tu número de transacción generado por PAYPAL es: </p> <b>' + data.id + '</b><br/><br/>Error: ' + error.message +
          '<br/><br/><div style="font-size: 14px;"><p>Número de cliente: ' + cliente.client_number + '<br/>Nombre: ' + cliente.company_name + '<br/>Correo electrónico: ' + cliente.email + '<br/>Almacén: ' + cliente.almacenPre + '</p></div>');
        return of(error);
    }
  }
}
